/**
 * Do not edit directly
 * Generated on Wed, 16 Dec 2020 18:32:46 GMT
 */

export const AssetFontFamily = "PT Sans, sans-serif";
export const AssetFontImportUrl = "https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap";
export const ColorFillAlert = "hsl(353, 98%, 41%)";
export const ColorFillChevron = "hsl(82, 100%, 32%)";
export const ColorFillContainer = "hsl(0, 0%, 100%)";
export const ColorFillContainerArticle = "hsl(218, 28%, 92%)";
export const ColorFillContainerSection = "hsl(0, 0%, 100%)";
export const ColorFillDivideArticle = "hsl(218, 30%, 76%)";
export const ColorFillDivider = "hsl(220, 31%, 89%)";
export const ColorFillModalBackground = "hsl(0, 0%, 100%)";
export const ColorFillModalScreenBackground = "hsl(214, 88%, 14%)";
export const ColorFillPrimary = "hsl(205, 99%, 39%)";
export const ColorFillScreenBackground = "hsl(220, 38%, 97%)";
export const ColorFillSecondary = "hsl(82, 100%, 32%)";
export const ColorFillSectionHeader = "hsl(220, 38%, 97%)";
export const ColorFillTertiary = "hsl(37, 91%, 55%)";
export const ColorFontAlert = "hsl(0, 0%, 100%)";
export const ColorFontContainer = "hsl(0, 0%, 23%)";
export const ColorFontContainerArticle = "hsl(0, 0%, 23%)";
export const ColorFontContainerSection = "hsl(0, 0%, 23%)";
export const ColorFontPrimary = "hsl(0, 0%, 100%)";
export const ColorFontSecondary = "hsl(0, 0%, 100%)";
export const ColorFontSectionHeader = "hsl(0, 0%, 23%)";
export const ColorFontTertiary = "hsl(0, 0%, 100%)";
export const ShadowCardBlur = "4px";
export const ShadowCardColor = "hsla(205, 99%, 28%, 0.20)";
export const ShadowCardSpread = "0";
export const ShadowCardX = "0";
export const ShadowCardY = "2px";
export const ShadowHeaderBlur = "4px";
export const ShadowHeaderColor = "hsla(206, 100%, 11%, 0.20)";
export const ShadowHeaderSpread = "0";
export const ShadowHeaderX = "0";
export const ShadowHeaderY = "2px";
export const SizeFontTiny = "0.75px";
export const SizeFontSmall = "0.875px";
export const SizeFontMedium = "1px";
export const SizeFontLarge = "1.25px";
export const SizeFontXl = "1.5px";
export const SizeFontXxl = "2px";
export const SizeFontXxxl = "3px";
export const SizeFontBase = "1px";
export const SizeIconSmall = "15px";
export const SizeIconMedium = "30px";
export const SizeIconLarge = "60px";
export const SizeIconXl = "90px";
export const SizeIconXxl = "120px";
export const SizeSpacerXxs = "2px";
export const SizeSpacerXs = "5px";
export const SizeSpacerS = "10px";
export const SizeSpacerM = "15px";
export const SizeSpacerL = "30px";
export const SizeSpacerXl = "60px";
export const SizeSpacerXxl = "90px";